module.exports = __webpack_public_path__ + "static/media/textProduct_B2B.0632aa62.md";